(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frabya-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = value => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    const initCollection = root => {
      if (root.dataset.fyReady === 'true') return;
      root.dataset.fyReady = 'true';
      const input = root.querySelector('[data-fy-card-filter]');
      const cards = [...root.querySelectorAll('[data-fy-card]')];
      const empty = root.querySelector('[data-fy-filter-empty]');
      input.addEventListener('input', () => {
        const query = normalize(input.value);
        let visible = 0;
        cards.forEach(card => {
          const match = !query || normalize(`${card.dataset.title} ${card.dataset.tags} ${card.dataset.vendor}`).includes(query);
          card.hidden = !match;
          if (match) visible += 1;
        });
        empty.hidden = visible > 0;
      });
      root.querySelector('[data-fy-sort]').addEventListener('change', event => event.target.form.submit());
    };
    const init = scope => scope.querySelectorAll('[data-fy-collection]').forEach(initCollection);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frabya-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clean = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const addModels = (brand, models, level = 'ready') => models.map(model => ({ brand, model, label: `${brand} ${model}`, level }));
    const deviceCatalog = [
      ...addModels('Apple', ['iPhone XR', 'iPhone XS', 'iPhone XS Max', 'iPhone 11', 'iPhone 11 Pro', 'iPhone 11 Pro Max', 'iPhone SE 2020', 'iPhone 12 mini', 'iPhone 12', 'iPhone 12 Pro', 'iPhone 12 Pro Max', 'iPhone 13 mini', 'iPhone 13', 'iPhone 13 Pro', 'iPhone 13 Pro Max', 'iPhone SE 2022', 'iPhone 14', 'iPhone 14 Plus', 'iPhone 14 Pro', 'iPhone 14 Pro Max', 'iPhone 15', 'iPhone 15 Plus', 'iPhone 15 Pro', 'iPhone 15 Pro Max', 'iPhone 16', 'iPhone 16 Plus', 'iPhone 16 Pro', 'iPhone 16 Pro Max', 'iPhone 16e', 'iPhone 17', 'iPhone 17 Pro', 'iPhone 17 Pro Max', 'iPhone 17e', 'iPhone Air', 'iPhone 18 Pro', 'iPhone 18 Pro Max']),
      ...addModels('Samsung', ['Galaxy S20', 'Galaxy S20+', 'Galaxy S20 Ultra', 'Galaxy S21', 'Galaxy S21+', 'Galaxy S21 Ultra', 'Galaxy S22', 'Galaxy S22+', 'Galaxy S22 Ultra', 'Galaxy S23', 'Galaxy S23+', 'Galaxy S23 Ultra', 'Galaxy S23 FE', 'Galaxy S24', 'Galaxy S24+', 'Galaxy S24 Ultra', 'Galaxy S24 FE', 'Galaxy S25', 'Galaxy S25+', 'Galaxy S25 Ultra', 'Galaxy S25 Edge', 'Galaxy S25 FE', 'Galaxy S26', 'Galaxy S26+', 'Galaxy S26 Ultra', 'Galaxy S26 FE', 'Galaxy Note20', 'Galaxy Note20 Ultra', 'Galaxy Fold', 'Galaxy Z Fold2', 'Galaxy Z Fold3', 'Galaxy Z Fold4', 'Galaxy Z Fold5', 'Galaxy Z Fold6', 'Galaxy Z Fold7', 'Galaxy Z Fold8', 'Galaxy Z Fold8 Ultra', 'Galaxy Z Flip', 'Galaxy Z Flip 5G', 'Galaxy Z Flip3', 'Galaxy Z Flip4', 'Galaxy Z Flip5', 'Galaxy Z Flip6', 'Galaxy Z Flip7', 'Galaxy Z Flip7 FE', 'Galaxy Z Flip8', 'Galaxy Z TriFold', 'Galaxy XCover7', 'Galaxy XCover7 Pro']),
      ...addModels('Samsung', ['Galaxy A54', 'Galaxy A55', 'Galaxy A56', 'Galaxy A57', 'Galaxy A35', 'Galaxy A36', 'Galaxy A37', 'Galaxy A16 5G', 'Galaxy A17 5G', 'Galaxy A26', 'Galaxy A27', 'Galaxy XCover6 Pro'], 'likely'),
      ...addModels('Google', ['Pixel 3', 'Pixel 3 XL', 'Pixel 3a', 'Pixel 3a XL'], 'likely'),
      ...addModels('Google', ['Pixel 4', 'Pixel 4 XL', 'Pixel 4a', 'Pixel 4a 5G', 'Pixel 5', 'Pixel 5a', 'Pixel 6', 'Pixel 6 Pro', 'Pixel 6a', 'Pixel 7', 'Pixel 7 Pro', 'Pixel 7a', 'Pixel Fold', 'Pixel 8', 'Pixel 8 Pro', 'Pixel 8a', 'Pixel 9', 'Pixel 9 Pro', 'Pixel 9 Pro XL', 'Pixel 9 Pro Fold', 'Pixel 9a', 'Pixel 10', 'Pixel 10 Pro', 'Pixel 10 Pro XL', 'Pixel 10 Pro Fold', 'Pixel 10a']),
      ...addModels('Motorola', ['Razr 2019', 'Razr 5G', 'Razr 40', 'Razr 40 Ultra', 'Razr 50', 'Razr 50 Ultra', 'Razr 60', 'Razr 60 Ultra', 'Edge 40 Pro', 'Edge 40 Neo', 'Edge 50 Pro', 'Edge 50 Ultra', 'Edge 60 Pro', 'Moto G54 5G'], 'likely'),
      ...addModels('Xiaomi', ['12T Pro', '13', '13 Pro', '13 Lite', '13T', '13T Pro', '14', '14 Pro', '14T', '14T Pro', '15', '15 Pro', '15 Ultra'], 'likely'),
      ...addModels('Huawei', ['P40', 'P40 Pro', 'Mate 40 Pro', 'Pura 70 Pro'], 'likely'),
      ...addModels('Oppo', ['Find X3 Pro', 'Find X5', 'Find X5 Pro', 'Find X8', 'Find X8 Pro', 'Reno 5A', 'A55s 5G'], 'likely'),
      ...addModels('Honor', ['Magic4 Pro', 'Magic5 Pro', 'Magic6 Pro', 'Magic7 Pro', 'Magic V2', 'Magic V3', 'Magic V5', '90', '200 Pro'], 'likely'),
      ...addModels('Sony', ['Xperia 1 IV', 'Xperia 1 V', 'Xperia 1 VI', 'Xperia 5 IV', 'Xperia 5 V', 'Xperia 10 IV', 'Xperia 10 V', 'Xperia 10 VI'], 'likely'),
      ...addModels('OnePlus', ['11', '12', '13', 'Open'], 'likely'),
      ...addModels('Fairphone', ['Fairphone 4', 'Fairphone 5'], 'likely'),
      ...addModels('Nothing', ['Phone (3)'], 'likely')
    ].map(device => ({ ...device, search: clean(`${device.label} ${device.model}`) }));

    const findDevice = model => {
      const value = clean(model);
      if (!value) return null;
      return deviceCatalog.find(device => device.search === value || clean(device.label) === value || clean(device.model) === value) || null;
    };

    const classifyModel = model => {
      const device = findDevice(model);
      if (device) return device.level;
      const value = clean(model);
      if (/iphone (x|8|7|6|5|4)\b/.test(value) || value === 'iphone se') return 'bad';
      if (/pixel\s*[12]\b/.test(value)) return 'bad';
      if (/galaxy (s(1[0-9]|[1-9])|note (1[0-9]|[1-9]))\b/.test(value)) return 'bad';
      return 'unknown';
    };

    const initHeader = root => {
      if (root.dataset.fyReady === 'true') return;
      root.dataset.fyReady = 'true';
      const menu = root.querySelector('[data-fy-menu-dialog]');
      const compat = root.querySelector('[data-fy-compat-dialog]');
      const result = root.querySelector('[data-fy-compat-result]');
      const resultTitle = root.querySelector('[data-fy-result-title]');
      const resultCopy = root.querySelector('[data-fy-result-copy]');
      const resultIcon = root.querySelector('[data-fy-result-icon]');
      const modelField = root.querySelector('[data-fy-device-model]');
      const modelSuggestions = root.querySelector('[data-fy-model-suggestions]');
      const languageSelect = root.querySelector('[data-fy-language-select]');

      if (languageSelect && languageSelect.form) {
        const languageForm = languageSelect.form;
        const availableLanguages = Array.from(languageSelect.options).map(option => option.value);
        const switchLanguage = () => {
          const target = new URL(window.location.href);
          const codes = availableLanguages.join('|');
          target.pathname = target.pathname.replace(new RegExp(`^/(${codes})(?=/|$)`), '') || '/';
          if (languageSelect.value !== 'it') target.pathname = `/${languageSelect.value}${target.pathname}`;
          window.location.assign(target.href);
        };
        languageForm.addEventListener('submit', event => {
          event.preventDefault();
          switchLanguage();
        });

        languageSelect.addEventListener('change', () => {
          try {
            localStorage.setItem('frabya-language-choice', languageSelect.value);
          } catch (error) {
            // Language switching still works when browser storage is unavailable.
          }
          switchLanguage();
        });

        if (!window.Shopify || !window.Shopify.designMode) {
          let preferredLanguage = '';
          let attemptedLanguage = '';
          try {
            preferredLanguage = localStorage.getItem('frabya-language-choice') || '';
            attemptedLanguage = sessionStorage.getItem('frabya-language-auto-attempt') || '';
          } catch (error) {
            preferredLanguage = '';
          }

          if (!availableLanguages.includes(preferredLanguage)) {
            const browserLanguage = (navigator.languages && navigator.languages[0]) || navigator.language || '';
            preferredLanguage = browserLanguage.toLowerCase().startsWith('it') ? 'it' : 'en';
          }

          if (
            availableLanguages.includes(preferredLanguage) &&
            preferredLanguage !== languageSelect.dataset.currentLanguage &&
            attemptedLanguage !== preferredLanguage
          ) {
            try {
              sessionStorage.setItem('frabya-language-auto-attempt', preferredLanguage);
            } catch (error) {
              // The locale form remains usable without session storage.
            }
            languageSelect.value = preferredLanguage;
            switchLanguage();
          }
        }
      }

      const showResult = (level, title, copy) => {
        result.dataset.level = level;
        resultTitle.textContent = title;
        resultCopy.textContent = copy;
        resultIcon.textContent = level === 'ready' ? '✓' : level === 'bad' ? '×' : level === 'likely' ? '!' : '?';
      };

      const showClassified = level => {
        if (level === 'ready') showResult('ready', root.dataset.readyTitle, root.dataset.readyCopy);
        else if (level === 'likely') showResult('likely', root.dataset.likelyTitle, root.dataset.likelyCopy);
        else if (level === 'bad') showResult('bad', root.dataset.badTitle, root.dataset.badCopy);
        else showResult('unknown', root.dataset.unknownTitle, root.dataset.unknownCopy);
      };

      let activeSuggestion = -1;
      let suggestionButtons = [];
      const closeSuggestions = () => {
        modelSuggestions.hidden = true;
        modelSuggestions.replaceChildren();
        modelField.setAttribute('aria-expanded', 'false');
        modelField.removeAttribute('aria-activedescendant');
        activeSuggestion = -1;
        suggestionButtons = [];
      };
      const chooseDevice = device => {
        modelField.value = device.label;
        closeSuggestions();
        showClassified(device.level);
        modelField.focus();
      };
      const setActiveSuggestion = index => {
        if (!suggestionButtons.length) return;
        activeSuggestion = (index + suggestionButtons.length) % suggestionButtons.length;
        suggestionButtons.forEach((button, buttonIndex) => button.setAttribute('aria-selected', String(buttonIndex === activeSuggestion)));
        modelField.setAttribute('aria-activedescendant', suggestionButtons[activeSuggestion].id);
        suggestionButtons[activeSuggestion].scrollIntoView({ block: 'nearest' });
      };
      const showSuggestions = () => {
        const query = clean(modelField.value);
        if (query.length < 2) {
          closeSuggestions();
          return;
        }
        const matches = deviceCatalog.map(device => {
          const position = device.search.indexOf(query);
          return position === -1 ? null : { device, score: position === 0 ? 100 : 70 - position };
        }).filter(Boolean).sort((first, second) => second.score - first.score || first.device.label.localeCompare(second.device.label)).slice(0, 10);
        if (!matches.length) {
          closeSuggestions();
          showClassified(classifyModel(modelField.value));
          return;
        }
        modelSuggestions.replaceChildren();
        matches.forEach(({ device }, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.id = `${modelSuggestions.id}-option-${index}`;
          button.setAttribute('role', 'option');
          button.setAttribute('aria-selected', 'false');
          const name = document.createElement('span');
          name.textContent = device.label;
          const brand = document.createElement('small');
          brand.textContent = device.brand;
          button.append(name, brand);
          button.addEventListener('pointerdown', event => event.preventDefault());
          button.addEventListener('click', () => chooseDevice(device));
          modelSuggestions.appendChild(button);
        });
        modelSuggestions.hidden = false;
        modelField.setAttribute('aria-expanded', 'true');
        suggestionButtons = Array.from(modelSuggestions.querySelectorAll('[role="option"]'));
        activeSuggestion = -1;
      };

      modelField.addEventListener('input', showSuggestions);
      modelField.addEventListener('focus', showSuggestions);
      modelField.addEventListener('blur', () => window.setTimeout(closeSuggestions, 120));
      modelField.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' && !modelSuggestions.hidden) {
          event.preventDefault();
          setActiveSuggestion(activeSuggestion + 1);
        } else if (event.key === 'ArrowUp' && !modelSuggestions.hidden) {
          event.preventDefault();
          setActiveSuggestion(activeSuggestion - 1);
        } else if (event.key === 'Enter') {
          event.preventDefault();
          if (!modelSuggestions.hidden && suggestionButtons.length) suggestionButtons[Math.max(activeSuggestion, 0)].click();
          else showClassified(classifyModel(modelField.value));
        } else if (event.key === 'Escape') {
          closeSuggestions();
        }
      });

      const detectDevice = async () => {
        const ua = navigator.userAgent || '';
        let model = '';
        if (navigator.userAgentData && navigator.userAgentData.getHighEntropyValues) {
          try {
            const details = await navigator.userAgentData.getHighEntropyValues(['model', 'platform']);
            model = details.model || '';
          } catch (error) {
            model = '';
          }
        }
        if (/iPhone|iPad|iPod/i.test(ua)) {
          showResult('likely', root.dataset.iphoneTitle, root.dataset.iphoneCopy);
        } else if (/Android/i.test(ua)) {
          if (model) {
            modelField.value = model;
            showClassified(classifyModel(model));
          } else {
            showResult('unknown', root.dataset.androidTitle, root.dataset.androidCopy);
          }
        } else {
          showResult('unknown', root.dataset.desktopTitle, root.dataset.desktopCopy);
        }
      };

      root.querySelectorAll('[data-fy-menu-open]').forEach(button => {
        button.addEventListener('click', () => menu.showModal());
      });
      document.querySelectorAll('[data-fy-compat-open]').forEach(button => {
        if (button.dataset.fyCompatBound === 'true') return;
        button.dataset.fyCompatBound = 'true';
        button.addEventListener('click', () => {
          if (!compat.open) compat.showModal();
          detectDevice();
        });
      });
      root.querySelectorAll('[data-fy-dialog-close]').forEach(button => {
        button.addEventListener('click', () => button.closest('dialog').close());
      });
      [menu, compat].forEach(dialog => {
        dialog.addEventListener('click', event => {
          if (event.target === dialog) dialog.close();
        });
      });
      detectDevice();
    };

    const init = scope => scope.querySelectorAll('[data-frabya-header]').forEach(initHeader);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frabya-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const boot = () => {
    const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const destinationRecords = [
      { it: 'Bosnia ed Erzegovina', en: 'Bosnia and Herzegovina', aliases: ['bosnia', 'bosnia erzegovina', 'bosnia ed erzegovina', 'bosnia and herzegovina', 'medjugorje', 'medjugorie', 'madjugorie', 'međugorje', 'mostar', 'sarajevo'], terms: ['bosnia', 'bosnia erzegovina', 'bosnia ed erzegovina', 'bosnia and herzegovina'], regions: [] },
      { it: 'Stati Uniti', en: 'United States', aliases: ['stati uniti', 'united states', 'usa', 'new york', 'miami', 'los angeles', 'san francisco', 'las vegas', 'chicago', 'california'], terms: ['stati uniti', 'united states', 'usa'], regions: ['america', 'americhe', 'americas'] },
      { it: 'Canada', en: 'Canada', aliases: ['canada', 'toronto', 'vancouver', 'montreal'], terms: ['canada'], regions: ['america', 'americhe', 'americas'] },
      { it: 'Messico', en: 'Mexico', aliases: ['messico', 'mexico', 'citta del messico', 'mexico city', 'cancun', 'tulum'], terms: ['messico', 'mexico'], regions: ['america', 'americhe', 'americas'] },
      { it: 'Brasile', en: 'Brazil', aliases: ['brasile', 'brazil', 'rio de janeiro', 'san paolo', 'sao paulo'], terms: ['brasile', 'brazil'], regions: ['america', 'americhe', 'americas'] },
      { it: 'Argentina', en: 'Argentina', aliases: ['argentina', 'buenos aires'], terms: ['argentina'], regions: ['america', 'americhe', 'americas'] },
      { it: 'Colombia', en: 'Colombia', aliases: ['colombia', 'bogota', 'cartagena'], terms: ['colombia'], regions: ['america', 'americhe', 'americas'] },
      { it: 'Perù', en: 'Peru', aliases: ['peru', 'lima'], terms: ['peru'], regions: ['america', 'americhe', 'americas'] },
      { it: 'Cile', en: 'Chile', aliases: ['cile', 'chile', 'santiago'], terms: ['cile', 'chile'], regions: ['america', 'americhe', 'americas'] },
      { it: 'Giappone', en: 'Japan', aliases: ['giappone', 'japan', 'tokyo', 'osaka', 'kyoto'], terms: ['giappone', 'japan'], regions: ['asia', 'pacifico', 'asia pacific'] },
      { it: 'Thailandia', en: 'Thailand', aliases: ['thailandia', 'tailandia', 'thailand', 'bangkok', 'phuket', 'chiang mai'], terms: ['thailandia', 'tailandia', 'thailand'], regions: ['asia', 'pacifico', 'asia pacific'] },
      { it: 'Emirati Arabi Uniti', en: 'United Arab Emirates', aliases: ['emirati', 'emirati arabi uniti', 'united arab emirates', 'uae', 'dubai', 'abu dhabi'], terms: ['emirati', 'united arab emirates', 'uae'], regions: ['asia', 'medio oriente', 'middle east'] },
      { it: 'Singapore', en: 'Singapore', aliases: ['singapore'], terms: ['singapore'], regions: ['asia', 'pacifico', 'asia pacific'] },
      { it: 'Indonesia', en: 'Indonesia', aliases: ['indonesia', 'bali', 'jakarta'], terms: ['indonesia'], regions: ['asia', 'pacifico', 'asia pacific'] },
      { it: 'Corea del Sud', en: 'South Korea', aliases: ['corea del sud', 'south korea', 'korea', 'seul', 'seoul', 'busan'], terms: ['corea del sud', 'south korea', 'korea'], regions: ['asia', 'pacifico', 'asia pacific'] },
      { it: 'Cina', en: 'China', aliases: ['cina', 'china', 'pechino', 'beijing', 'shanghai', 'shenzhen'], terms: ['cina', 'china'], regions: ['asia', 'pacifico', 'asia pacific'] },
      { it: 'Hong Kong', en: 'Hong Kong', aliases: ['hong kong'], terms: ['hong kong'], regions: ['asia', 'pacifico', 'asia pacific'] },
      { it: 'Australia', en: 'Australia', aliases: ['australia', 'sydney', 'melbourne', 'brisbane'], terms: ['australia'], regions: ['asia', 'pacifico', 'asia pacific', 'oceania'] },
      { it: 'Nuova Zelanda', en: 'New Zealand', aliases: ['nuova zelanda', 'new zealand', 'auckland'], terms: ['nuova zelanda', 'new zealand'], regions: ['asia', 'pacifico', 'asia pacific', 'oceania'] },
      { it: 'Regno Unito', en: 'United Kingdom', aliases: ['regno unito', 'united kingdom', 'uk', 'inghilterra', 'londra', 'london', 'manchester', 'edimburgo', 'edinburgh'], terms: ['regno unito', 'united kingdom', 'uk'], regions: ['europa', 'europe'] },
      { it: 'Francia', en: 'France', aliases: ['francia', 'france', 'parigi', 'paris', 'nizza', 'nice', 'lione', 'lyon'], terms: ['francia', 'france'], regions: ['europa', 'europe'] },
      { it: 'Italia', en: 'Italy', aliases: ['italia', 'italy', 'roma', 'rome', 'milano', 'milan', 'venezia', 'venice', 'firenze', 'florence', 'napoli', 'naples'], terms: ['italia', 'italy'], regions: ['europa', 'europe'] },
      { it: 'Spagna', en: 'Spain', aliases: ['spagna', 'spain', 'madrid', 'barcellona', 'barcelona', 'valencia', 'siviglia', 'seville'], terms: ['spagna', 'spain'], regions: ['europa', 'europe'] },
      { it: 'Portogallo', en: 'Portugal', aliases: ['portogallo', 'portugal', 'lisbona', 'lisbon', 'porto'], terms: ['portogallo', 'portugal'], regions: ['europa', 'europe'] },
      { it: 'Germania', en: 'Germany', aliases: ['germania', 'germany', 'berlino', 'berlin', 'monaco di baviera', 'munich', 'francoforte', 'frankfurt'], terms: ['germania', 'germany'], regions: ['europa', 'europe'] },
      { it: 'Paesi Bassi', en: 'Netherlands', aliases: ['paesi bassi', 'netherlands', 'olanda', 'holland', 'amsterdam', 'rotterdam'], terms: ['paesi bassi', 'netherlands', 'olanda'], regions: ['europa', 'europe'] },
      { it: 'Grecia', en: 'Greece', aliases: ['grecia', 'greece', 'atene', 'athens', 'santorini', 'mykonos'], terms: ['grecia', 'greece'], regions: ['europa', 'europe'] },
      { it: 'Turchia', en: 'Turkey', aliases: ['turchia', 'turkey', 'turkiye', 'istanbul', 'antalya'], terms: ['turchia', 'turkey', 'turkiye'], regions: ['europa', 'europe', 'asia'] },
      { it: 'Egitto', en: 'Egypt', aliases: ['egitto', 'egypt', 'il cairo', 'cairo', 'sharm el sheikh', 'hurghada'], terms: ['egitto', 'egypt'], regions: ['africa'] },
      { it: 'Marocco', en: 'Morocco', aliases: ['marocco', 'morocco', 'marrakech', 'casablanca', 'agadir'], terms: ['marocco', 'morocco'], regions: ['africa'] },
      { it: 'Sudafrica', en: 'South Africa', aliases: ['sudafrica', 'south africa', 'citta del capo', 'cape town', 'johannesburg'], terms: ['sudafrica', 'south africa'], regions: ['africa'] },
      { it: 'Maldive', en: 'Maldives', aliases: ['maldive', 'maldives', 'male'], terms: ['maldive', 'maldives'], regions: ['asia', 'pacifico', 'asia pacific'] },
      { it: 'Qatar', en: 'Qatar', aliases: ['qatar', 'doha'], terms: ['qatar'], regions: ['asia', 'medio oriente', 'middle east'] },
      { it: 'Arabia Saudita', en: 'Saudi Arabia', aliases: ['arabia saudita', 'saudi arabia', 'riyadh', 'gedda', 'jeddah'], terms: ['arabia saudita', 'saudi arabia'], regions: ['asia', 'medio oriente', 'middle east'] },
      { it: 'Europa', en: 'Europe', aliases: ['europa', 'europe'], terms: ['europa', 'europe', 'cont europa'], regions: ['europa', 'europe'] },
      { it: 'Americhe', en: 'Americas', aliases: ['america', 'americhe', 'americas'], terms: ['america', 'americhe', 'americas', 'cont americhe'], regions: ['america', 'americhe', 'americas'] },
      { it: 'Asia e Pacifico', en: 'Asia Pacific', aliases: ['asia', 'asia pacifico', 'asia pacific', 'pacifico'], terms: ['asia', 'pacifico', 'asia pacific', 'cont asia'], regions: ['asia', 'pacifico', 'asia pacific'] },
      { it: 'Africa', en: 'Africa', aliases: ['africa'], terms: ['africa', 'cont africa'], regions: ['africa'] },
      { it: 'Mondo', en: 'Global', aliases: ['mondo', 'world', 'worldwide', 'globale', 'global'], terms: ['mondo', 'world', 'worldwide', 'globale', 'global', 'multi region'], regions: [] }
    ];
    (window.FrabyaCountryRecords || []).forEach(record => {
      const existing = destinationRecords.find(item => normalize(item.it) === normalize(record.it) || normalize(item.en) === normalize(record.en));
      if (existing) {
        existing.aliases = Array.from(new Set([...existing.aliases, ...record.aliases]));
        existing.terms = Array.from(new Set([...existing.terms, ...record.terms]));
      } else destinationRecords.push(record);
    });
    const destinationIndex = destinationRecords.reduce((index, record) => {
      [...record.aliases, record.it, record.en].forEach(alias => { index[normalize(alias)] = record; });
      return index;
    }, {});
    const worldwideTerms = ['mondo', 'world', 'worldwide', 'globale', 'global', 'multi region'];

    const initHome = root => {
      const hwDialog = root.querySelector('[data-fy-hw-dialog]');
      const openHalloween = () => {
        if (!root.classList.contains('fy-halloween') || Date.now() >= Number(root.dataset.fyHalloweenUntil) * 1000) return;
        if (hwDialog && !hwDialog.open && !document.querySelector('dialog[open]')) hwDialog.showModal();
      };
      root.querySelectorAll('[data-fy-hw-open]').forEach(button => button.addEventListener('click', openHalloween));
      if (hwDialog) {
        hwDialog.addEventListener('close', () => { try { sessionStorage.setItem('fy-halloween-2026-dismissed', '1'); } catch(error) {} });
        hwDialog.addEventListener('click', event => { if(event.target === hwDialog) hwDialog.close(); });
        hwDialog.querySelector('[data-fy-hw-find]').addEventListener('click', () => hwDialog.close());
        hwDialog.querySelector('[data-fy-hw-copy]').addEventListener('click', async event => {
          const button = event.currentTarget;
          const code = hwDialog.querySelector('[data-fy-hw-code]');
          const status = hwDialog.querySelector('[data-fy-hw-status]');
          try { await navigator.clipboard.writeText(code.value); status.textContent = button.dataset.copied; }
          catch(error) { code.focus(); code.select(); status.textContent = button.dataset.manual; }
        });

      }
      const pumpkin = root.querySelector('[data-fy-hw-game]');
      if (pumpkin) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        let position = 0;
        let pumpkinTimer;
        let pumpkinStopped = false;
        const pumpkinStarted = performance.now();
        const stopPumpkin = () => {
          pumpkinStopped = true;
          window.clearInterval(pumpkinTimer);
          pumpkin.hidden = true;
        };
        const placePumpkin = () => {
          const elapsed = performance.now() - pumpkinStarted;
          if (pumpkinStopped || !root.isConnected || !root.classList.contains('fy-halloween') || Date.now() >= Number(root.dataset.fyHalloweenUntil) * 1000) { stopPumpkin(); return; }
          if (elapsed >= 10000 && elapsed < 14000) { pumpkin.hidden = true; return; }
          if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && pumpkin.matches(':hover, :focus-visible') && !document.querySelector('dialog[open]')) return;
          if (!root.classList.contains('fy-halloween') || document.hidden || document.querySelector('dialog[open]') || /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '')) { pumpkin.hidden = true; return; }
          const viewport = window.visualViewport;
          const height = viewport?.height || window.innerHeight;
          const width = viewport?.width || window.innerWidth;
          const offsetX = viewport?.offsetLeft || 0;
          const offsetY = viewport?.offsetTop || 0;
          const header = document.querySelector('#header-group');
          const minY = Math.max(offsetY + 20, (header?.getBoundingClientRect().bottom || 140) + 16);
          const maxY = offsetY + height - 94;
          const left = offsetX + 10;
          const right = offsetX + width - 70;
          if (maxY < minY || right < left) { pumpkin.hidden = true; return; }
          const yAt = ratio => minY + (maxY - minY) * ratio;
          const xAt = ratio => left + (right - left) * ratio;
          const positions = elapsed < 14000
            ? [.5, .28, .75, .4, .62].map(ratio => ({ x: left, y: yAt(ratio) }))
            : [
                { x: left, y: yAt(.45) },
                { x: xAt(.5), y: minY },
                { x: right, y: yAt(.3) },
                { x: xAt(.3), y: maxY },
                { x: left, y: yAt(.7) },
                { x: xAt(.25), y: minY },
                { x: right, y: yAt(.5) },
                { x: xAt(.55), y: maxY }
              ];
          let placed = false;
          for (let attempt = 0; attempt < positions.length; attempt += 1) {
            const { x, y } = positions[(position + attempt) % positions.length];
            if (x + 60 > offsetX + width - 145 && y + 58 > offsetY + height - 230) continue;
            const blocked = [y + 4, y + 29, y + 54].some(py => [x + 2, x + 28, x + 56].some(px =>
              document.elementsFromPoint(px, py).some(el => el !== pumpkin && !pumpkin.contains(el) && el.closest('button, a, input, select, textarea, [role="button"], iframe, [role="dialog"]'))
            ));
            if (blocked) continue;
            pumpkin.style.left = x + 'px';
            pumpkin.style.top = y + 'px';
            placed = true;
            pumpkin.hidden = false;
            pumpkin.classList.remove('fy-hw-game--hop');
            if (!reduced.matches) {
              window.requestAnimationFrame(() => pumpkin.classList.add('fy-hw-game--hop'));
            }
            position = (position + attempt + 1) % positions.length;
            break;
          }
          if (!placed) pumpkin.hidden = true;
        };
        pumpkinTimer = window.setInterval(placePumpkin, 2000);
        document.addEventListener('visibilitychange', placePumpkin);
        window.addEventListener('resize', placePumpkin, { passive: true });
        hwDialog?.addEventListener('close', placePumpkin);
        pumpkin.addEventListener('click', stopPumpkin);
        placePumpkin();
      }
      if (root.classList.contains('fy-halloween')) {
        const deadline = Number(root.dataset.fyHalloweenUntil) * 1000;
        let expiryTimer;
        const expireHalloween = () => {
          window.clearTimeout(expiryTimer);
          const remaining = deadline - Date.now();
          if (remaining <= 0) {
            root.classList.remove('fy-halloween');
            const expiredDialog = root.querySelector('[data-fy-hw-dialog]');
            if (expiredDialog?.open) expiredDialog.close();
          }
          else expiryTimer = window.setTimeout(expireHalloween, Math.min(remaining, 2147483647));
        };
        expireHalloween();
        document.addEventListener('visibilitychange', expireHalloween);
      }
      if (root.dataset.fyReady === 'true') return;
      root.dataset.fyReady = 'true';
      const finder = root.querySelector('[data-fy-finder]');
      const destination = root.querySelector('[data-fy-destination]');
      const duration = root.querySelector('[data-fy-duration]');
      const usage = root.querySelector('[data-fy-usage]');
      const results = root.querySelector('[data-fy-results]');
      const products = Array.from(root.querySelectorAll('[data-fy-product]'));
      const title = root.querySelector('[data-fy-results-title]');
      const count = root.querySelector('[data-fy-results-count]');
      const noMatch = root.querySelector('[data-fy-no-match]');
      const whatsappLink = root.querySelector('[data-fy-whatsapp-link]');
      const language = root.dataset.language === 'it' ? 'it' : 'en';

      const resolveDestination = raw => {
        const normalized = normalize(raw);
        const record = destinationIndex[normalized];
        if (!record) return { raw: raw.trim(), label: raw.trim(), terms: [normalized], regions: [], known: false };
        const label = record[language];
        return { raw: raw.trim(), label, terms: record.terms, regions: record.regions, regional: ['Europa', 'Americhe', 'Asia e Pacifico', 'Africa', 'Mondo'].includes(record.it), known: true };
      };

      const parseDestinations = value => value.split(/[,;\n]|\s+\+\s+/).map(part => part.trim()).filter(Boolean).map(resolveDestination);

      const destinationStrength = (coverageTags, place) => {
        return place.terms.some(term => {
          const normalized = normalize(term);
          return normalized && coverageTags.some(tag => tag === normalized || tag === `dest ${normalized}`);
        }) ? 3 : 0;
      };

      const verifiedPlan = variant => window.FrabyaPlanCatalog?.[variant.dataset.sku.trim()] || null;
      const eligibleVariants = (item, places) => Array.from(item.querySelectorAll('[data-fy-variant]')).filter(variant => {
        const plan = verifiedPlan(variant);
        return plan && (!places.length || places.every(place => place.regional ? destinationStrength(JSON.parse(item.dataset.coverageTags || '[]').map(normalize), place) : destinationStrength(plan.coverage, place)));
      });

      const getScore = (item, places, trip, profile) => {
        let coverageTags;
        try { coverageTags = JSON.parse(item.dataset.coverageTags).map(normalize); }
        catch { coverageTags = []; }
        const strengths = places.map(place => destinationStrength(coverageTags, place));
        const eligible = eligibleVariants(item, places);
        if (!eligible.length || trip > 0 && !eligible.some(variant => verifiedPlan(variant).days > 0)) return null;
        if (places.length) strengths.fill(3);
        let score = places.length ? strengths.reduce((total, strength) => total + strength * 80, 0) : 10;
        if (places.length > 1 && strengths.every(Boolean)) score += 250;
        score += strengths.filter(strength => strength === 3).length * 45;
        const productTitle = normalize(item.dataset.title);
        score += places.filter(place => place.terms.some(term => term && productTitle.includes(normalize(term)))).length * 400;
        const tags = item.dataset.tags || '';
        const durations = Array.from(tags.matchAll(/durata-(\d+)g/g), match => Number(match[1]));
        if (trip > 0 && durations.length) {
          const valid = durations.filter(days => days >= trip);
          if (valid.length) score += 30 - Math.min(...valid.map(days => days - trip)) * .25;
          else score -= 30;
        }
        if (profile === 'heavy' && /(unlimited|illimitati|gb-(50|100)|50gb|100gb|500gb)/i.test(tags + item.dataset.title)) score += 24;
        if (profile === 'standard' && /(gb-(10|15|20)|10gb|15gb|20gb)/i.test(tags + item.dataset.title)) score += 20;
        if (profile === 'light' && /(gb-(1|2|3|5|6)|1gb|2gb|3gb|5gb|6gb)/i.test(tags + item.dataset.title)) score += 18;
        const popularityRank = Number(item.dataset.popularity || products.length);
        score += Math.max(0, 25 - (popularityRank - 1) * .65);
        return score;
      };

      const parseVariantPlan = (item, variant, trip, places = []) => {
        const plan = verifiedPlan(variant);
        const days = plan?.days || 0;
        const roaming = Boolean(plan?.roaming && (!places.length || places.some(place => place.regional || !destinationStrength(plan.roaming.domesticTerms, place))));
        const dataGb = roaming ? plan.roaming.dataGb : plan?.dataGb || 0;
        const unlimited = !roaming && (plan?.unlimited || false);
        const daily = !roaming && (plan?.daily || false);
        const monthly = roaming && plan.roaming.monthly;
        const divisor = trip > 0 && days > 0 ? Math.min(days, trip) : days || trip || 1;
        const perDay = unlimited ? 100 : daily ? dataGb : dataGb / divisor;
        return { days, dataGb, unlimited, daily, perDay, roaming, monthly };
      };

      const getUsageTarget = profile => profile === 'light' ? .6 : profile === 'standard' ? 1 : profile === 'heavy' ? 3 : 0;
      const meetsUsageProfile = (plan, profile) => profile === 'any' || plan.unlimited || plan.perDay >= getUsageTarget(profile);

      const reducedPriceBefore = {"eSIM-KDDI-UL09":3499,"eSIM-KDDI-UL10":3599,"eSIM-KDDI-UL11":3999,"eSIM-KDDI-UL12":4499,"eSIM-KDDI-UL13":4699,"eSIM-KDDI-UL14":4999,"eSIM-KDDI-UL15":5299,"eSIM-KDDI-UL16":5699,"eSIM-KDDI-UL17":6099,"eSIM-KDDI-UL18":6449,"eSIM-KDDI-UL19":6799,"eSIM-KDDI-UL20":7249,"eSIM-KDDI-UL21":7599,"eSIM-KDDI-UL26":9149,"eSIM-KDDI-UL31":11099};
      const reductionExpires = Date.parse('2026-11-13T23:00:00+01:00');
      const isReducedVariant = variant => Date.now() < reductionExpires && Number(variant.dataset.price) < (reducedPriceBefore[variant.dataset.sku] || 0);
      const isRecentProduct = item => {
        const age = Date.now() / 1000 - Number(item.dataset.createdAt || 0);
        return age >= 0 && age < 30 * 86400;
      };
      const updatePriceBadge = (item, variant) => {
        const badge = item.querySelector('[data-fy-update-badge]');
        if (!badge) return;
        const kind = variant && isReducedVariant(variant) ? 'price' : variant && isRecentProduct(item) ? 'new' : '';
        badge.hidden = !kind;
        badge.textContent = kind === 'price' ? badge.dataset.priceLabel : kind === 'new' ? badge.dataset.newLabel : '';
      };
      const chooseIdealVariant = (item, trip, profile, places) => {
        const eligible = eligibleVariants(item, places).filter(variant => trip <= 0 || verifiedPlan(variant).days > 0);
        const matching = eligible.filter(variant => meetsUsageProfile(parseVariantPlan(item, variant, trip, places), profile));
        const variants = matching.length ? matching : eligible;
        if (!variants.length) return null;
        if (!trip && profile === 'any' && !places.length) {
          const featured = variants.find(variant => variant.dataset.sku === 'eSIM-KDDI-UL15' && isReducedVariant(variant));
          if (featured) return featured;
        }
        const targetPerDay = getUsageTarget(profile);
        return variants.map(variant => {
          const plan = parseVariantPlan(item, variant, trip, places);
          const price = Number(variant.dataset.price || 0);
          let score = 0;
          if (trip > 0 && plan.days > 0) {
            score += plan.days >= trip ? 1800 - Math.min(plan.days - trip, 90) * 6 : 500 - Math.ceil(trip / plan.days) * 18;
          } else if (trip > 0) {
            score -= 1000;
          }
          if (profile === 'heavy') {
            score += plan.unlimited ? 520 : Math.min(plan.perDay, 10) * 42;
          } else if (targetPerDay > 0 && plan.perDay > 0) {
            const ratio = plan.perDay / targetPerDay;
            score += 340 - Math.abs(Math.log(ratio)) * 115;
            if (ratio < 1) score -= 90;
          } else if (profile === 'any') {
            score += 120;
          }
          score -= price / 5000;
          return { variant, score };
        }).sort((first, second) => second.score - first.score)[0]?.variant || null;
      };

      const getResultVariants = (item, trip, profile, places) => {
        let variants = eligibleVariants(item, places).filter(variant => trip <= 0 || parseVariantPlan(item, variant, trip, places).days > 0);
        const hasCompletePlan = variants.some(variant => {
          const plan = parseVariantPlan(item, variant, trip, places);
          return (trip <= 0 || plan.days >= trip) && meetsUsageProfile(plan, profile);
        });
        if (hasCompletePlan && trip > 0) variants = variants.filter(variant => parseVariantPlan(item, variant, trip, places).days >= trip);
        const groups = new Map();
        variants.forEach(variant => {
          const plan = parseVariantPlan(item, variant, trip, places);
          const key = plan.daily || plan.unlimited ? 'daily' : 'total';
          if (!groups.has(key)) groups.set(key, []);
          groups.get(key).push(variant);
        });
        return Array.from(groups.values()).map(options => {
          const scoped = { dataset: item.dataset, querySelectorAll: () => options };
          return chooseIdealVariant(scoped, trip, profile, places);
        }).filter(Boolean);
      };

      const getSuggestedQuantity = (plan, trip) => trip > 0 && plan.days > 0 && plan.days < trip ? Math.ceil(trip / plan.days) : 1;
      const getSuggestedCost = (item, trip, profile, places) => {
        const variant = chooseIdealVariant(item, trip, profile, places);
        updatePriceBadge(item, variant);
        if (!variant) return Infinity;
        return Number(variant.dataset.price) * getSuggestedQuantity(parseVariantPlan(item, variant, trip, places), trip);
      };
      const compareSuggestedPlans = (first, second) => Number(Boolean(second.suitable)) - Number(Boolean(first.suitable)) || first.cost - second.cost || second.score - first.score;

      const updateIdealComposition = (item, trip, profile, places) => {
        const panel = item.querySelector('[data-fy-ideal-composition]');
        if (!panel) return;
        const cardLinks = item.querySelectorAll('.fy-card a[href]');
        cardLinks.forEach(link => {
          if (!link.dataset.baseHref) link.dataset.baseHref = link.href;
        });
        const variant = chooseIdealVariant(item, trip, profile, places);
        if (!variant) {
          panel.hidden = true;
          cardLinks.forEach(link => { link.href = link.dataset.baseHref; });
          return;
        }
        const durationLabel = duration.options[duration.selectedIndex].textContent.trim();
        const usageLabel = root.dataset[`usage${profile.charAt(0).toUpperCase()}${profile.slice(1)}`] || root.dataset.usageAny;
        const plan = parseVariantPlan(item, variant, trip, places);
        const quantity = getSuggestedQuantity(plan, trip);
        const shorter = quantity > 1;
        panel.querySelector('[data-fy-plan-data]').textContent = plan.unlimited ? root.dataset.planUnlimited : plan.dataGb > 0 ? (plan.daily ? root.dataset.planDaily : root.dataset.planTotal).replace('%GB%', plan.dataGb) : root.dataset.planUnknownData;
        if (plan.roaming) panel.querySelector('[data-fy-plan-data]').textContent = `${plan.dataGb} GB ${root.dataset.roamingLabel}${plan.monthly ? root.dataset.roamingMonthly : ''}`;
        panel.querySelector('[data-fy-plan-days]').textContent = plan.days > 0 ? (plan.days === 1 ? root.dataset.planDaysOne : root.dataset.planDays).replace('%DAYS%', plan.days) : root.dataset.unknownDuration;
        panel.querySelector('[data-fy-plan-quantity]').textContent = (quantity === 1 ? root.dataset.planQuantityOne : root.dataset.planQuantity).replace('%QUANTITY%', quantity);
        let reason = root.dataset.idealFor.replace('%DURATION%', durationLabel).replace('%USAGE%', usageLabel);
        if (shorter) reason = root.dataset.shortPlan.replace('%DAYS%', plan.days).replace('%QUANTITY%', quantity).replace('%TRIP%', trip);
        else if (trip > 0 && plan.days > trip) reason = root.dataset.longPlan.replace('%DAYS%', plan.days).replace('%TRIP%', trip);
        else if (trip > 0 && !plan.days) reason = root.dataset.unknownDuration;
        panel.querySelector('[data-fy-ideal-reason]').textContent = reason;
        panel.querySelector('[data-fy-ideal-title]').textContent = variant.dataset.title === 'Default Title' ? item.dataset.title : variant.dataset.title;
        if (plan.roaming) panel.querySelector('[data-fy-ideal-title]').textContent = `${plan.dataGb} GB ${root.dataset.roamingLabel}${plan.monthly ? root.dataset.roamingMonthly : ''}`;
        const note = panel.querySelector('[data-fy-ideal-note]');
        const targetPerDay = getUsageTarget(profile);
        const usageAlternative = targetPerDay > 0 && !plan.unlimited && plan.perDay < targetPerDay;
        panel.querySelector('.fy-ideal-composition__badge').textContent = usageAlternative ? root.dataset.alternativeBadge : root.dataset.suggestedBadge;
        panel.classList.toggle('fy-ideal-composition--alternative', usageAlternative);
        note.hidden = !shorter && !usageAlternative;
        note.textContent = [shorter ? root.dataset.repeatNote : '', usageAlternative ? root.dataset.usageAlternative : ''].filter(Boolean).join(' ');
        const total = new Intl.NumberFormat(language, { style: 'currency', currency: root.dataset.currency || 'EUR' }).format(Number(variant.dataset.price) * quantity / 100);
        panel.querySelector('[data-fy-ideal-price]').textContent = shorter ? root.dataset.totalPrice.replace('%QUANTITY%', quantity).replace('%TOTAL%', total) : variant.dataset.priceFormatted;
        const url = new URL(variant.dataset.url, window.location.origin);
        if (shorter) url.searchParams.set('quantity', quantity);
        panel.querySelector('[data-fy-ideal-link]').href = url.href;
        panel.querySelector('[data-fy-cart-id]').value = variant.dataset.id;
        panel.querySelector('[data-fy-cart-quantity]').value = quantity;
        const missing = item._fyMissing || [];
        const partial = missing.length > 0;
        panel.querySelector('[data-fy-partial]').hidden = !partial;
        panel.querySelector('[data-fy-partial-confirm]').hidden = !partial;
        const acceptance = panel.querySelector('[data-fy-accept-exclusions]');
        acceptance.required = partial;
        acceptance.checked = false;
        const actions = panel.querySelector('[data-fy-missing-actions]');
        actions.replaceChildren();
        if (partial) {
          const covered = item._fyCovered;
          const missingNames = missing.map(place => place.label).join(', ');
          const badge = panel.querySelector('[data-fy-partial-title]');
          badge.textContent = badge.dataset.label.replace('%COVERED%', covered.length).replace('%TOTAL%', covered.length + missing.length);
          panel.querySelector('.fy-ideal-composition__badge').textContent = badge.textContent;
          panel.querySelector('[data-fy-covered]').textContent = `${panel.querySelector('[data-fy-covered]').dataset.label} ${covered.map(place => place.label).join(', ')}`;
          panel.querySelector('[data-fy-excluded]').textContent = `${panel.querySelector('[data-fy-excluded]').dataset.label} ${missingNames}`;
          panel.querySelector('[data-fy-confirm-excluded]').textContent = missingNames;
          missing.forEach(place => {
            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = `${actions.dataset.searchLabel} ${place.label}`;
            button.addEventListener('click', () => {
              destination.value = place.label;
              render();
              scrollToResults();
            });
            actions.appendChild(button);
          });
        }
        cardLinks.forEach(link => { link.href = url.href; });
        panel.hidden = false;
      };

      const editDistance = (first, second) => {
        const rows = Array.from({ length: second.length + 1 }, (_, index) => index);
        for (let firstIndex = 1; firstIndex <= first.length; firstIndex += 1) {
          let previous = rows[0];
          rows[0] = firstIndex;
          for (let secondIndex = 1; secondIndex <= second.length; secondIndex += 1) {
            const saved = rows[secondIndex];
            rows[secondIndex] = Math.min(
              rows[secondIndex] + 1,
              rows[secondIndex - 1] + 1,
              previous + (first[firstIndex - 1] === second[secondIndex - 1] ? 0 : 1)
            );
            previous = saved;
          }
        }
        return rows[second.length];
      };

      const matchDestination = (record, query) => {
        let best = null;
        record.aliases.forEach(alias => {
          const normalizedAlias = normalize(alias);
          let score = 0;
          if (normalizedAlias === query) score = 120;
          else if (normalizedAlias.startsWith(query)) score = 100 - normalizedAlias.length * .1;
          else if (normalizedAlias.includes(query)) score = 75 - normalizedAlias.indexOf(query);
          else if (query.length >= 4) {
            const distance = editDistance(query, normalizedAlias);
            if (distance <= 2) score = 55 - distance * 10;
          }
          if (score && (!best || score > best.score)) best = { alias, score };
        });
        return best;
      };

      const setupSuggestions = input => {
        const combobox = input.closest('[data-fy-combobox]');
        const panel = combobox.querySelector('[data-fy-suggestions]');
        let activeIndex = -1;
        let options = [];

        const close = () => {
          panel.hidden = true;
          panel.replaceChildren();
          input.setAttribute('aria-expanded', 'false');
          input.removeAttribute('aria-activedescendant');
          activeIndex = -1;
          options = [];
        };

        const activeQuery = () => normalize(input.value.split(/[,;\n]/).pop());

        const selectRecord = record => {
          const parts = input.value.split(/[,;\n]/);
          parts[parts.length - 1] = ` ${record[language]}`;
          input.value = parts.map(part => part.trim()).filter(Boolean).join(', ');
          close();
          input.dispatchEvent(new Event('change', { bubbles: true }));
          if (input === destination) render();
          input.focus();
        };

        const setActive = index => {
          if (!options.length) return;
          activeIndex = (index + options.length) % options.length;
          options.forEach((option, optionIndex) => option.setAttribute('aria-selected', String(optionIndex === activeIndex)));
          input.setAttribute('aria-activedescendant', options[activeIndex].id);
        };

        const open = () => {
          const query = activeQuery();
          if (!query) {
            close();
            return;
          }
          const suggestions = destinationRecords.map(record => {
            const match = matchDestination(record, query);
            if (!match) return null;
            const place = { raw: record[language], label: record[language], terms: record.terms, regions: record.regions, known: true };
            const available = products.filter(item => getScore(item, [place], 0, 'any') !== null).length;
            return available ? { record, match, available } : null;
          }).filter(Boolean).sort((first, second) => second.match.score - first.match.score).slice(0, 6);
          if (!suggestions.length) {
            close();
            return;
          }
          panel.replaceChildren();
          suggestions.forEach(({ record, match, available }, index) => {
            const option = document.createElement('button');
            option.type = 'button';
            option.id = `${panel.id}-option-${index}`;
            option.className = 'fy-destination-suggestion';
            option.setAttribute('role', 'option');
            option.setAttribute('aria-selected', 'false');
            const icon = document.createElement('span');
            icon.className = 'fy-destination-suggestion__icon';
            icon.setAttribute('aria-hidden', 'true');
            icon.textContent = '⌖';
            const copy = document.createElement('span');
            const title = document.createElement('strong');
            title.textContent = record[language];
            const detail = document.createElement('small');
            const matchedAlias = normalize(match.alias) === normalize(record[language]) ? '' : match.alias;
            detail.textContent = matchedAlias ? root.dataset.suggestionAlias.replace('%PLACE%', matchedAlias) : record.regions[0] || '';
            const availability = document.createElement('em');
            availability.textContent = root.dataset.plansAvailable.replace('%COUNT%', String(available));
            copy.append(title, detail);
            option.append(icon, copy, availability);
            option.addEventListener('pointerdown', event => event.preventDefault());
            option.addEventListener('click', () => selectRecord(record));
            panel.appendChild(option);
          });
          panel.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          options = Array.from(panel.querySelectorAll('[role="option"]'));
          activeIndex = -1;
        };

        input.addEventListener('input', open);
        input.addEventListener('focus', open);
        input.addEventListener('keydown', event => {
          if (panel.hidden) return;
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            setActive(activeIndex + 1);
          } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            setActive(activeIndex - 1);
          } else if (event.key === 'Enter' && activeIndex >= 0) {
            event.preventDefault();
            options[activeIndex].click();
          } else if (event.key === 'Escape') {
            close();
          }
        });
        input.addEventListener('blur', () => window.setTimeout(close, 120));
      };

      const render = event => {
        if (event) event.preventDefault();
        const query = destination.value.trim();
        window.fySharedSearch = {destination: query, duration: duration.value, usage: usage.value};
        const searching = Boolean(query || Number(duration.value) > 0 || usage.value !== 'any');
        root.classList.toggle('fy-home--searching', searching);
        const places = parseDestinations(query);
        const trip = Number(duration.value || 0);
        const profile = usage.value;
        results.querySelectorAll('[data-fy-expanded-plan]').forEach(item => item.remove());
        const candidates = [];
        products.forEach(item => {
          if (!searching) { candidates.push(item); return; }
          getResultVariants(item, trip, profile, places).forEach(selected => {
            const skus = [selected.dataset.sku];
            const candidate = item.cloneNode(true);
            candidate.dataset.fyExpandedPlan = '';
            candidate.classList.remove('fy-product-grid__item--first');
            candidate.querySelectorAll('[data-fy-variant]').forEach(variant => {
              if (!skus.includes(variant.dataset.sku)) variant.remove();
            });
            candidates.push(candidate);
          });
        });
        const distinctPlaces = places.filter((place, index) => places.findIndex(other => normalize(other.label) === normalize(place.label)) === index);
        if (!candidates.length && distinctPlaces.length > 1 && distinctPlaces.every(place => place.known && !place.regional)
          && !products.some(item => eligibleVariants(item, distinctPlaces).length)) {
          products.forEach(item => {
            const groups = new Map();
            item.querySelectorAll('[data-fy-variant]').forEach(variant => {
              const plan = verifiedPlan(variant);
              if (!plan) return;
              const covered = distinctPlaces.filter(place => destinationStrength(plan.coverage, place));
              if (!covered.length || covered.length === distinctPlaces.length) return;
              const key = covered.map(place => place.label).join('|');
              if (!groups.has(key)) groups.set(key, { covered, options: [] });
              groups.get(key).options.push(variant);
            });
            const options = Array.from(groups.values()).map(group => {
              const scope = { dataset: item.dataset, querySelectorAll: () => group.options };
              return { ...group, selected: getResultVariants(scope, trip, profile, group.covered) };
            }).filter(group => group.selected.length);
            options.sort((a, b) => b.covered.length - a.covered.length || Math.min(...a.selected.map(v => Number(v.dataset.price) * getSuggestedQuantity(parseVariantPlan(item, v, trip, a.covered), trip))) - Math.min(...b.selected.map(v => Number(v.dataset.price) * getSuggestedQuantity(parseVariantPlan(item, v, trip, b.covered), trip))));
            const best = options[0];
            if (!best) return;
            best.selected.forEach(selected => {
              const candidate = item.cloneNode(true);
              candidate.dataset.fyExpandedPlan = '';
              candidate._fyCovered = best.covered;
              candidate._fyMissing = distinctPlaces.filter(place => !best.covered.includes(place));
              candidate.querySelectorAll('[data-fy-variant]').forEach(variant => {
                if (variant.dataset.sku !== selected.dataset.sku) variant.remove();
              });
              candidates.push(candidate);
            });
          });
        }
        let ranked = candidates.map(item => ({ item, score: getScore(item, item._fyCovered || places, trip, profile), cost: getSuggestedCost(item, trip, profile, item._fyCovered || places) })).filter(entry => entry.score !== null);
        ranked.forEach(entry => {
          const variant = chooseIdealVariant(entry.item, trip, profile, entry.item._fyCovered || places);
          entry.suitable = Boolean(variant && meetsUsageProfile(parseVariantPlan(entry.item, variant, trip, entry.item._fyCovered || places), profile));
        });
        const suitable = ranked.filter(entry => entry.suitable);
        ranked.sort(query || trip > 0 || profile !== 'any' ? ((a, b) => (b.item._fyCovered?.length || places.length) - (a.item._fyCovered?.length || places.length) || compareSuggestedPlans(a, b)) : (first, second) => second.score - first.score);
        if (!searching) {
          const recent = ranked.filter(entry => isRecentProduct(entry.item)).sort((a, b) => Number(b.item.dataset.createdAt) - Number(a.item.dataset.createdAt));
          const reduced = ranked.filter(entry => Array.from(entry.item.querySelectorAll('[data-fy-variant]')).some(isReducedVariant));
          const featured = [...recent.slice(0, 3), ...reduced.slice(0, 2)];
          ranked = [...new Set([...featured, ...ranked])];
        }
        products.forEach(item => { item.hidden = true; item.classList.remove('fy-product-grid__item--first'); });
        candidates.forEach(item => updateIdealComposition(item, trip, profile, item._fyCovered || places));
        const limit = query ? ranked.length : 6;
        ranked.slice(0, limit).forEach((entry, index) => {
          entry.item.classList.toggle('fy-product-grid__item--first', searching && index === 0);
          entry.item.hidden = false;
          results.appendChild(entry.item);
        });
        const visible = Math.min(ranked.length, limit);
        noMatch.hidden = ranked.length > 0;
        const separatePanel = root.querySelector('[data-fy-separate-search]');
        const separateActions = root.querySelector('[data-fy-separate-actions]');
        const uniquePlaces = places.filter((place, index) => places.findIndex(other => normalize(other.label) === normalize(place.label)) === index);
        const separatelyCovered = ranked.length === 0 && uniquePlaces.length > 1
          && uniquePlaces.every(place => place.known && !place.regional)
          && !products.some(item => eligibleVariants(item, uniquePlaces).length)
          && uniquePlaces.every(place => products.some(item => getResultVariants(item, trip, profile, [place]).length));
        separatePanel.hidden = !separatelyCovered;
        root.querySelector('[data-fy-no-match-default]').hidden = separatelyCovered;
        separateActions.replaceChildren();
        if (separatelyCovered) uniquePlaces.forEach(place => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = `${separateActions.dataset.searchLabel} ${place.label}`;
          button.addEventListener('click', () => {
            destination.value = place.label;
            render();
            scrollToResults();
          });
          separateActions.appendChild(button);
        });
        if (ranked.length === 0) {
          const request = root.dataset.whatsappMessage.replace('%DESTINATIONS%', query || '-');
          whatsappLink.href = `https://wa.me/${root.dataset.whatsappPhone}?text=${encodeURIComponent(request)}`;
        }
        const resolved = places.map(place => normalize(place.raw) === normalize(place.label) ? place.label : `${place.raw} (${place.label})`).join(' + ');
        title.textContent = query ? `${root.dataset.resultsTitle}: ${resolved}` : root.dataset.popularTitle;
        count.textContent = visible ? `${visible} ${visible === 1 ? root.dataset.matchSingle : root.dataset.matchPlural}` : '';
        if (visible && ranked[0].item._fyMissing?.length) count.textContent = `${visible} ${root.dataset.partialResults}`;
        if (visible && profile !== 'any' && !suitable.length) count.textContent += ` · ${root.dataset.noUsageMatch}`;
      };

      let scrollAnimation;
      const scrollToResults = () => {
        window.cancelAnimationFrame(scrollAnimation);
        const heading = title.closest('.fy-results-heading') || title.parentElement;
        const header = document.querySelector('#header-group');
        const offset = (header ? header.getBoundingClientRect().height : 88) + 16;
        const target = Math.max(0, window.scrollY + heading.getBoundingClientRect().top - offset);
        const start = window.scrollY;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          window.scrollTo({ top: target, behavior: 'instant' });
          return;
        }
        const started = performance.now();
        const step = now => {
          const progress = Math.min(1, (now - started) / 850);
          const eased = progress < .5 ? 4 * progress ** 3 : 1 - (-2 * progress + 2) ** 3 / 2;
          window.scrollTo({ top: start + (target - start) * eased, behavior: 'instant' });
          if (progress < 1) scrollAnimation = window.requestAnimationFrame(step);
        };
        scrollAnimation = window.requestAnimationFrame(step);
      };
      finder.addEventListener('submit', event => {
        window.clearTimeout(renderTimer);
        const initialScroll = window.scrollY;
        render(event);
        window.scrollTo({ top: initialScroll, behavior: 'instant' });
        const active = document.activeElement;
        if (active && finder.contains(active)) active.blur();
        window.setTimeout(scrollToResults, 180);
      });
      root.querySelectorAll('[data-fy-suggest-input]').forEach(setupSuggestions);
      let renderTimer;
      destination.addEventListener('input', () => {
        window.clearTimeout(renderTimer);
        renderTimer = window.setTimeout(render, 180);
      });
      duration.addEventListener('change', render);
      usage.addEventListener('change', render);
      root.querySelectorAll('[data-fy-destination-chip]').forEach(button => {
        button.addEventListener('click', () => {
          destination.value = button.dataset.fyDestinationChip;
          finder.requestSubmit();
        });
      });
      root.querySelector('[data-fy-add-destination]').addEventListener('click', () => {
        const current = destination.value.trim();
        destination.value = current ? `${current}, ` : '';
        destination.focus();
      });
      const heroForm = root.querySelector('[data-fy-hero-form]');
      heroForm.addEventListener('submit', event => {
        event.preventDefault();
        destination.value = root.querySelector('[data-fy-hero-destination]').value;
        root.querySelector('#trova-la-tua-esim').scrollIntoView({ behavior: 'smooth', block: 'start' });
        render();
      });
      const sharedParams = new URLSearchParams(location.search);
      if (sharedParams.get('fy_search') === '1') {
        destination.value = (sharedParams.get('fy_destination') || '').slice(0, 500);
        for (const [control, key] of [[duration, 'fy_days'], [usage, 'fy_usage']]) {
          const value = sharedParams.get(key);
          if (Array.from(control.options).some(option => option.value === value)) control.value = value;
        }
      }
      render();
      if (sharedParams.get('fy_search') === '1') window.setTimeout(scrollToResults, 180);
    };

    const init = scope => scope.querySelectorAll('[data-frabya-home]').forEach(initHome);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
    };
    if (window.FrabyaPlanCatalog) boot();
    else window.addEventListener('fy:catalog-ready', boot, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frabya-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initProduct = root => {
      if (root.dataset.fyReady === 'true') return;
      root.dataset.fyReady = 'true';
      const applyChatClearance = () => {
        const host = document.querySelector('whatsapp-chat-by-squadkin');
        if (!host?.shadowRoot) return false;
        if (!host.shadowRoot.querySelector('[data-fy-chat-clearance]')) {
          const style = document.createElement('style');
          style.dataset.fyChatClearance = '';
          style.textContent = '@media (max-width: 600px) { .squadkin-wrapper-container.squadkin-wrapper-container { bottom: calc(112px + env(safe-area-inset-bottom, 0px) + var(--sk-keyboard-offset, 0px)) !important; } }';
          host.shadowRoot.appendChild(style);
        }
        return true;
      };
      if (!applyChatClearance()) {
        const chatObserver = new MutationObserver(() => {
          if (applyChatClearance()) chatObserver.disconnect();
        });
        chatObserver.observe(document.body, { childList: true, subtree: true });
        customElements.whenDefined('whatsapp-chat-by-squadkin').then(() => {
          if (applyChatClearance()) chatObserver.disconnect();
        });
        window.addEventListener('pagehide', () => chatObserver.disconnect(), { once: true });
      }
      const mainImage = root.querySelector('[data-fy-main-image]');
      root.querySelectorAll('[data-fy-thumb]').forEach(button => {
        button.addEventListener('click', () => {
          if (!mainImage) return;
          mainImage.src = button.dataset.src;
          mainImage.alt = button.dataset.alt;
          root.querySelectorAll('[data-fy-thumb]').forEach(item => item.classList.toggle('is-active', item === button));
        });
      });

      const quantityInput = root.querySelector('[data-fy-quantity]');
      const quantityNote = root.querySelector('[data-fy-quantity-note]');
      const requestedQuantity = Number(new URL(window.location.href).searchParams.get('quantity'));
      if (quantityInput) {
        if (Number.isInteger(requestedQuantity) && requestedQuantity >= 1 && requestedQuantity <= 99) { quantityInput.value = requestedQuantity; quantityInput.dispatchEvent(new Event('change', { bubbles: true })); }
        const updateQuantity = () => { quantityNote.hidden = Number(quantityInput.value) <= 1; };
        quantityInput.addEventListener('input', updateQuantity);
        updateQuantity();
      }
      const select = root.querySelector('[data-fy-variant-select]');
      const coverage = root.querySelector('[data-fy-coverage]');
      const updateCoverage = () => {
        const sku = select ? select.options[select.selectedIndex].dataset.sku : coverage.dataset.sku;
        const plan = window.FrabyaPlanCatalog?.[sku];
        const balance = root.querySelector('[data-fy-balance]');
        if (balance) balance.querySelector('[data-fy-balance-instructions]').textContent = balance.dataset[plan?.balanceMethod] || balance.dataset.unknown;
        const list = coverage.querySelector('[data-fy-coverage-countries]');
        list.replaceChildren();
        coverage.querySelector('[data-fy-coverage-validity]').textContent = plan?.days ? (plan.days === 1 ? coverage.dataset.daysOne : coverage.dataset.days).replace('%DAYS%', plan.days) : coverage.dataset.unknown;
        if (!plan) return;
        const labels = new Set();
        const coveredTerms = new Set();
        (window.FrabyaCountryRecords || []).forEach(record => {
          if (record.terms.some(term => plan.coverage.includes(term.toLowerCase()))) {
            labels.add(coverage.dataset.language === 'it' ? record.it : record.en);
            record.terms.forEach(term => coveredTerms.add(term.toLowerCase()));
          }
        });
        [...plan.coverage.filter(term => !coveredTerms.has(term.toLowerCase())), ...(plan.unresolved || [])].forEach(term => labels.add(term));
        Array.from(labels).sort((a, b) => a.localeCompare(b, coverage.dataset.language)).forEach(label => {
          const item = document.createElement('li'); item.textContent = label; list.appendChild(item);
        });
      };
      window.addEventListener('fy:catalog-ready', updateCoverage);
      updateCoverage();
      const price = root.querySelector('[data-fy-price]');
      const stickyPrice = root.querySelector('[data-fy-sticky-price]');
      const add = root.querySelector('[data-fy-add]');
      const stickyAdd = root.querySelector('[data-fy-sticky-buy] button');
      const addLabel = root.querySelector('[data-fy-add-label]');
      if (select) {
        select.addEventListener('change', () => {
          const option = select.options[select.selectedIndex];
          updateCoverage();
          const available = option.dataset.available === 'true';
          price.textContent = option.dataset.price;
          stickyPrice.textContent = option.dataset.price;
          add.disabled = !available;
          stickyAdd.disabled = !available;
          addLabel.textContent = available ? root.dataset.addLabel : root.dataset.soldLabel;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url);
        });
      }
    };
    const init = scope => scope.querySelectorAll('[data-fy-product]').forEach(initProduct);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
